<template>
  <div style="position: relative;">
    <div class="size-detail" v-if="sizeDetailList.length != 0">
      <div v-for="(item,idx) in sizeDetailList[0]" class="size-detail-table-row">
        <div class="size-detail-table-item"></div>
        <div v-for="(items,index) in sizeDetailList" class="size-detail-table-item" 
          :style="{ 'width':sizeDetailList.length > 5 ? '20%' : ( 100 / sizeDetailList.length) + '%'}"
        >
          <span>
            {{items[idx]}}
          </span>
          
        </div>
      </div>
    </div>

    <div v-if="sizeImageKeyUrlList.length" style="margin-top:8px">
      <img v-for="val in sizeImageKeyUrlList" :src="val" mode="widthFix"></image>
    </div>
  </div>
</template>

<script>
import http from "@/utils/axios";
export default {
  data(){
    return {
      sizeDetailList:[],
      sizeImageKeyUrlList:[],
    }
  },
  created() {
    this.getSizeSetList()
  },
  methods:{
    getSizeSetList(){
      let commodityId = this.$route.query.id ? this.$route.query.id : this.$route.query.commodityId
      if(!commodityId){
        return 
      }
      if(!commodityId) return
      http({
        url: "order/size/selectGoodsSize/" + commodityId,
        method: "get"
      }).then(rps => {
        if(rps.data['id']){
          this.sizeImageKeyUrlList = rps.data.sizeImageKeyUrlList || []
          this.sizeDetailList = rps.data.sizeDataList || []
          this.$loading.hide();
        }
      }).catch(()=>{
        this.$loading.hide();
      })
    },

  }
}
</script>

<style lang="less" scoped>
img{
  width: 100%;
  height: 100%;
}
.size-detail{
  font-size: 22px;
  overflow-x: scroll;
  background-color: #FFF;
}
.size-detail-table-row{
  width: 100%;
  text-align: center;
  display: flex;
  font-size: 22px!important;
}
.size-detail-table-row:nth-child(1) .size-detail-table-item{
  background-color: #FAFAFA!important;
  height: 54px;
  span{
    
    white-space:normal;
    word-wrap:break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.size-detail-table-item{
  flex: 1;
  height: 34px;
  padding: 10px 0;
  min-width: 20%;
  line-height: 28px;
  background: #fff;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #E8E8E8;
  span{
    margin: auto;
    white-space:nowrap;
    word-wrap:break-word;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.size-detail-table-row .size-detail-table-item:nth-child(2){
  position: absolute;
  z-index: 999;
}
.size-detail-btn{
  background: #FAFAFA;
  text-align: center;
  padding: 12px;
}
.size-detail-btn image{
  height:30px;
  width:30px;
  position: relative;
  top: 6px;
}
</style>